import { Component, Input } from '@angular/core';
import { BidListStatusCounts, GetBidListStatus, BidListFilterService, ClearAllSelectedBidListVehicles, ClearAllSelectedVehiclesUuid } from 'remarketing-angular-library';
import { BidListToggleService } from '../../../services/bid-list-toggle/bid-list-toggle.service';
import { Store } from '@ngxs/store';
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'bidlist-status-filter',
    templateUrl: './bidlist-status-filter.component.html',
    styleUrls: ['./bidlist-status-filter.component.scss'],
    imports: [TranslocoDirective, CommonModule]
})
export class BidlistStatusFilterComponent {
  @Input() bidListStatusCounts: BidListStatusCounts;
  @Input() filteredStatus: string;

  ALL = GetBidListStatus.ALL;
  WON = GetBidListStatus.WON;
  OFFER = GetBidListStatus.OFFERS;
  OUTBID = GetBidListStatus.OUTBID;
  LEADING = GetBidListStatus.LEADING;

  constructor(
    private readonly store: Store,
    readonly bidListFilterService: BidListFilterService,
    private readonly bidListToggleService: BidListToggleService
  ) {}

  isActiveFilter(filterValue: string): boolean {
    return this.filteredStatus === filterValue;
  }

  clearBidListState() {
    this.store.dispatch(new ClearAllSelectedVehiclesUuid());
    this.bidListToggleService.reset();
    this.store.dispatch(new ClearAllSelectedBidListVehicles());
  }

  filterByStatus(filterValue: string): void {
    const newBidListSort = this.bidListFilterService.updateBidListSort({ bidListStatus: filterValue });
    this.bidListFilterService.navigateBidListToBidList(newBidListSort);
    if (!this.isActiveFilter(filterValue)) {
      this.clearBidListState();
    }
  }
}
